// extracted by mini-css-extract-plugin
module.exports = {"icon":"AuditIcon_icon__RRnAk","noIcon":"AuditIcon_noIcon__uwXxn"};